import LegalPage from './LegalPage';
import PrivacyContent from './PrivacyContent';

export const PRIVACY_META = {
  title: 'Privacy Policy',
  updated: '13 August 2026 · Version 2.2',
  intro:
    'How VIB3 collects, uses, and protects personal data under the EU General Data Protection Regulation (GDPR) and applicable national data protection law.',
};

/**
 * Privacy Policy v2.2. The canonical copy lives on the marketing site
 * (https://vib3.tech/privacy); this in-app version mirrors it. Cookie Notice links point
 * to the canonical https://vib3.tech/cookies. Review with counsel before relying on it.
 *
 * v2.2 draft (VIBE-1480): adds LinkedIn Ads and Apple Search Ads platform-data
 * subsections. Pending legal sign-off — do not treat as the live policy until
 * approved and published to both this page and https://vib3.tech/privacy.html.
 *
 * The body lives in PrivacyContent so the onboarding Sign step can show the
 * same document in a dialog without a second copy of the text.
 */
export default function PrivacyPage() {
  return (
    <LegalPage {...PRIVACY_META}>
      <PrivacyContent />
    </LegalPage>
  );
}
